<script>
import CardsTabPage from '@/pages/giftCard/cards/Cards-tab-page.vue';
import WrapperTabPage from '@/pages/giftCard/wrapper/Wrapper-tab-page.vue';
import ImagesTabPage from '@/pages/giftCard/images/Images-tab-page.vue';

export default {
  components: {
    CardsTabPage,
    ImagesTabPage,
    WrapperTabPage,
  },
};
</script>

<template>
  <div v-if="this.$route.params.type === 'images'">
    <images-tab-page />
  </div>
  <div v-else-if="this.$route.params.type === 'wrapper'">
    <wrapper-tab-page />
  </div>
  <div v-else>
    <cards-tab-page />
  </div>
</template>

<style scoped lang="scss">

</style>
